import {StackScreenProps} from '@react-navigation/stack'
import React from 'react'

import {usePageViewedAnalytics} from 'src/lib/Analytics/usePageViewedAnalytics'
import {AppEvents} from 'src/lib/Analytics/app_events'
import {TrackAppEvent} from 'src/lib/Analytics/analytics_compat'
import {MilitarySurveyGQLContainer} from 'src/products/general/MilitarySurvey/MilitarySurveyGQLContainer'
import {WorkflowPreReqFulfillScreenProps, WorkflowsStackParams} from 'src/workflows/types'

export type MilitarySurveyWorkflowsContainerProps = WorkflowPreReqFulfillScreenProps &
  StackScreenProps<WorkflowsStackParams, 'MilitarySurvey'>

const MilitarySurveyWorkflowContainer: React.FC<MilitarySurveyWorkflowsContainerProps> = (
  props: MilitarySurveyWorkflowsContainerProps,
) => {
  const {navigation, onPreReqFulfilled} = props

  usePageViewedAnalytics({
    eventName: AppEvents.Name.military_questionnaire_screen_viewed,
    eventCategory: AppEvents.Category.Onboarding,
    eventArgs: {
      navContainerType: 'Workflows',
    },
  })

  const handleContinue = async (isMilitary: boolean): Promise<void> => {
    // if isMilitary is true, we will navigate you to the MilitaryNotEligible screen. This is not within workflows as it does not map to a backend prereq. Instead, it is defined in Routes.tsx
    if (isMilitary === true) {
      TrackAppEvent(
        AppEvents.Name.military_questionnaire_screen_completed,
        AppEvents.Category.Onboarding,
        {
          isMilitary: true,
        },
      )
      const parentNavigation = navigation.getParent()
      parentNavigation?.navigate('MilitaryNotEligible')
    } else {
      TrackAppEvent(
        AppEvents.Name.military_questionnaire_screen_completed,
        AppEvents.Category.Onboarding,
        {
          isMilitary: false,
        },
      )

      await onPreReqFulfilled()
    }
  }
  return <MilitarySurveyGQLContainer onContinue={handleContinue} />
}

export {MilitarySurveyWorkflowContainer}
